import { useState } from "react";
import { Outlet } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
//
import Header from "./header";
import Nav from "./nav";
import { selectCurrentDialog } from "../../features/dialog/dialogSlice";
import { useSelector } from "react-redux";
import GlobalDialog from "../../components/dialog/GlobalDialog";
import GuidedTour from "../../components/tour/GuidedTour";
import MemberGuidedTour from "../../components/tour/MemberGuidedTour";
import { APP_BAR_DESKTOP, APP_BAR_MOBILE } from "./styleUtils";
import RolePreviewBanner from "../../features/rolePreview/RolePreviewBanner";

// ----------------------------------------------------------------------

const StyledRoot = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const Main = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(1),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 5,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(true);
  const dialog = useSelector(selectCurrentDialog);

  return (
    <>
      <RolePreviewBanner />
      <StyledRoot>
        <Header onOpenNav={() => setOpen(true)} />

        <Nav
          openNav={open}
          onOpenNav={() => setOpen(true)}
          onCloseNav={() => setOpen(false)}
        />

        <GuidedTour />
        <MemberGuidedTour />

        {dialog && <GlobalDialog dialog={dialog} />}

        <Main>
          <Outlet />
        </Main>
      </StyledRoot>
    </>
  );
}
